
import React from 'react'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CelebrationIcon from '@mui/icons-material/Celebration';
import TtkList from './TtkList';

const WeddingPlannerTTk = ({ data }) => {

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area Of Services :</b>&nbsp;<TtkList data={data?.areaOfWork} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Planning Type :</b>&nbsp;<TtkList data={data?.planningType} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LocalOfferIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Offered:</b>&nbsp;<TtkList data={data?.serviceOffered} /></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>No. of Events Covered :</b>&nbsp;<span>{data?.CoverdofEvents}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LocalOfferIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Starts At:</b>&nbsp;&#8377;&nbsp;<span>{data?.budget}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Fees Structure:</b>&nbsp;<span>{data?.Fees}</span></p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default WeddingPlannerTTk